import React from 'react'

function Footer() {
  return (
    <div className="footer-basic">
    <footer>
        <div className="social">
          <a href="https://github.com/xJuanPablo">
            <i class="icon ion-social-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/juan-pablo-archuleta/">
            <i class="icon ion-social-linkedin"></i>
          </a>
        </div>
        <p className="copyright">Weather App© 2023</p>
    </footer>
</div>
  )
}

export default Footer